module.exports = __webpack_public_path__ + "img/Prof.Ali_Minister_of_Health.2e5a052d.jpg";